module.exports = __webpack_public_path__ + "Group 15719.553ab01ae9a26f330444.png";